import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';

export class ZebraPrintRequestDto {//extends BaseBus {
    constructor(data?: ZebraPrintRequestDto) {
        //super(data);
    }
    CID(): any {
        return this.zebraPrinterId;
    }
    setId(id: any) {
        this.zebraPrinterId = id;
    }
    zebraPrinterId: any;
    zebraTemplateId: any;
    contentSource: string;
    requestDateTime: Date;
}
